/** @file useSetting: a React state that is saved to its localStorage setting on every change. */
import { useState } from 'react';
import type { LocalSetting } from './localSetting';

/** `[value, set]` like `useState`, starting from `setting.load()`; `set` also saves. */
export function useSetting<T>(setting: LocalSetting<T>): [T, (value: T) => void] {
  const [value, setValue] = useState<T>(setting.load);
  return [value, (next) => { setting.save(next); setValue(next); }];
}
